import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import NotificationAlert from "react-notification-alert";
import axios from 'axios';
import Cookies from "js-cookie";

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import TableCustom from 'views/pages/components/TableCustom';

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  FormGroup,
  Input,
} from "reactstrap";

export default function Note() {
  const { customerId } = useParams();
  const location = useLocation();
  const parentPath = {
    pathname: '/admin/customer/' + customerId + '/edit',
    state: {
      filter: location.state && location.state.filter? location.state.filter: ''
    }
  };
  const history = useHistory();
  const notificationAlert = useRef(null);

  const [token, setToken] = useState('');
  const [notes, setNotes] = useState([]);

  const [loading, setLoading] = useState(true);

  const [addModal, setAddModal] = useState(false);
  const [confirmShow, setConfirmShow] = useState(false);
  const [selectedNoteId, setSelectedNoteId] = useState('');

  const [note, setNote] = useState('');
  const [errors, setErrors] = useState('');

  const notify = (type, header, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {header}
          </span>
          <span data-notify="message">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5
    };
    notificationAlert.current.notificationAlert(options);
  };

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/customer/${customerId}/notes`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        setNotes(data.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify('warning', 'Warning', error.response.data.message ? error.response.data.message : error.response.statusText)
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const deleteNote = () => {
    axios({
      method: 'DELETE',
      url: constants.API_URL + '/customer/' + customerId + '/notes/' + selectedNoteId,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(response => {
        setConfirmShow(false);
        if (response.status == 200) {
          let data = response.data;
          console.log('deleted data :: ', data);
          setNotes(data.data);
          notify('success', 'Success', response.data.message);
        }
      })
      .catch(error => {
        console.error('error :: ', error);
        setConfirmShow(false);
        notify('warning', 'Warning', error.response.statusText);
      })
  }

  const editNote = (row) => {
    history.push({
      pathname: '/admin/customer/' + customerId + '/notes/' + row.id + '/edit',
      state: {
        filter: location.state && location.state.filter? location.state.filter: ''
      }
    })
  }

  const addNote = () => {
    axios({
      method: 'POST',
      url: constants.API_URL + '/customer/' + customerId + '/notes',
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: note,
    })
      .then(response => {
        setAddModal(false);
        setErrors('');
        if (response.status == 200) {
          let data = response.data;
          console.log('response data :: ', data);
          setNotes(data.data);
          notify('success', 'Success', response.data.message);
        }
      })
      .catch(error => {
        setErrors('');
        console.error('error :: ', error);
        if (error.response && error.response.status == 422) {
          let errors = error.response.data.errors;
          setErrors(errors);
          return;
        }
        setAddModal(false);
        notify('warning', 'Warning', error.response.statusText);
      })
  }

  const formatDate = (d) => {
    if (d) {
      let date = new Date(d);
      let option = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: 'numeric', minute: 'numeric', second: '2-digit',
        hour12: false,
      }
      let formatedDate = new Intl.DateTimeFormat('en-GB', option).format(date);
  
      return formatedDate;
    }
  }

  return (
    <>
      <CardsHeader name="Customers" parentName="Customer Management" currentName="Note List" parentPath={parentPath} />
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Notes</h1>
                  </Col>
                  <Col xs={4} className="text-right">
                    <Button className="w-100" color="success" type="button" onClick={() => setAddModal(true)}>Add note</Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom 
                  loading={loading}
                  items={notes}
                  keyField={`note`}
                  searchField={true}
                  columns={[
                    {
                      dataField: "note",
                      text: "Note",
                      sort: true
                    },
                    {
                      dataField: "created_at",
                      text: "Created at",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return formatDate(row.created_at)
                      }
                    },
                    {
                      dataField: "",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                color=""
                                role="button"
                                size="sm"
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem
                                  onClick={e => editNote(row)}
                                >
                                  Edit
                                </DropdownItem>
                                <DropdownItem
                                  onClick={e => {
                                    setConfirmShow(true);
                                    setSelectedNoteId(row.id);
                                  }}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={addModal}
          toggle={() => setAddModal(false)}
          size="lg"
          className="modal-dialog-centered modal-secondary"
        >
          <div className="modal-body">
            <form className="new-event--form">
              <FormGroup>
                <label className="form-control-label">Note</label>
                <Input
                  className="form-control-alternative edit-event--title"
                  placeholder="Note"
                  type="textarea"
                  rows="8"
                  onChange={(e) => setNote({
                    ...note,
                    note: e.target.value,
                  })}
                  invalid={errors && errors.note? true: false}
                />
                <div className="invalid-feedback">
                  {errors.note}
                </div>
              </FormGroup>
            </form>
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="primary"
              type="button"
              onClick={() => addNote()}
            >
              Save
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setAddModal(false)}
            >
              Cancel
            </Button>
          </div>
        </Modal>
        <Modal
          isOpen={confirmShow}
          toggle={() => setConfirmShow(false)}
          className="modal-dialog-centered modal-secondary"
        >
          <div className="modal-body">
            {`Are you sure you want to delete this task?`}
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="danger"
              type="button"
              onClick={() => deleteNote()}
            >
              {`Delete`}
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setConfirmShow(false)}
            >
              {`Cancel`}
            </Button>
          </div>
        </Modal>
      </Container>
    </>
  )
}